import { useState, type KeyboardEvent } from "react"
import { Avatar } from "./Avatar"
import styles from "./AvatarMenu.module.css"

/**
 * The signed-in person's pill, and the only way out of a portal — the header
 * carries no other affordance, so sign-out lives behind this.
 *
 * Signing out is the caller's: each surface has its own session endpoint to
 * call and its own sign-in screen to land on.
 */
export function AvatarMenu({
  name,
  onSignOut,
}: {
  name: string
  onSignOut: () => void
}) {
  const [open, setOpen] = useState(false)

  function closeOnEscape(event: KeyboardEvent) {
    if (event.key === "Escape") setOpen(false)
  }

  return (
    <div className={styles.menu}>
      <button
        type="button"
        className={styles.trigger}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        onKeyDown={closeOnEscape}
      >
        <span className={styles.name}>{name}</span>
        <Avatar name={name} />
      </button>
      {open && (
        <div className={styles.dropdown} role="menu">
          <button
            type="button"
            role="menuitem"
            className={styles.item}
            onClick={onSignOut}
            onKeyDown={closeOnEscape}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}
